import React, { Component } from 'react';
import Button from '../Buttons/Button/Button';
import { StarRating } from '../Ratings/Ratings';
import { T } from '../Response/Utils';

interface State {
  rating: any;
  response: any;
}
interface Props {
  surveySubmit: Function;
  surveys: any;
}

class Surveys extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      rating: [],
      response: []
    };
  }

  componentDidMount() {
    var toPush = {};
    this.props.surveys.surveyReponseDtos.map(sur => {
      var starname = 'rating' + sur.survey_parameters;
      toPush['' + starname + ''] = 0;
    });
    this.setState({
      rating: toPush,
      response: []
    });
  }

  onStarClick(name, nextValue) {
    let stateCopy = JSON.parse(JSON.stringify(this.state.rating));
    stateCopy[name] = nextValue;
    this.setState({
      rating: stateCopy
    });
    this.rated(name.toString(), nextValue.toString());
  }

  rated(pid, res) {
    let existingResponse = this.state.response;
    var responseObj = new Object();
    responseObj['surveyParameterId'] = pid.toString();
    responseObj['surveyResponse'] = res;

    existingResponse.map(e => {
      if (e['surveyParameterId'] === pid) {
        e['surveyResponse'] = res;
        responseObj = null;
        this.setState({
          response: existingResponse
        });
        return;
      }
    });
    if (responseObj) {
      this.state.response.push(responseObj);
    }
  }

  render() {
    return (
      <div
        tabIndex={0}
        className="sf-each-offer"
        style={{ wordBreak: 'break-word' }}
      >
        {/* closing/deleting surveys not possible yet */}
        {/* <IconButton
                  variant={'filled'}
                  size={'small'}
                  className="clickable card-close"
                  onClick={() => {
                    this.rated(
                      this.props.surveys.surveyReponseDtos[0].survey_parameters_id.toString(),
                      ''
                    );
                    this.surveySubmit(this.props.surveys.survey_id, this.props.surveys.userId);
                  }}
                  title={'Dismiss'}
                  image={'close'}
                /> */}
        <div className="each-offer-card-title">
          {this.props.surveys.survey_title}
        </div>
        <div className="each-offer-card-msg">
          {this.props.surveys.survey_description}
        </div>

        <div className="each-offer-card-content">
          {this.props.surveys.surveyReponseDtos.map((sur, index) => {
            var star_name = sur.survey_parameters_id;
            return (
              <div key={index} className="survey-rating">
                <div className="survey-rating-parameter">
                  {sur.survey_parameters}
                </div>

                <div className="dv-star-rating-star" style={{ width: '172px' }}>
                  <StarRating
                    name={sur.survey_parameters_id}
                    number={5}
                    filled={this.state.rating[star_name]}
                    onChange={this.onStarClick.bind(this)}
                    noOutlineHover
                    noLabel
                  />
                </div>
              </div>
            );
          })}
        </div>
        <Button
          className="each-offer-card-submit"
          onClick={this.props.surveySubmit.bind(
            this,
            this.props.surveys.survey_id,
            this.props.surveys.userId,
            this.state.response
          )}
          fullWidth
          disabled={
            this.state.response.length !==
            this.props.surveys.surveyReponseDtos.length
          }
        >
          <T labelName="submitLabel" />
        </Button>
      </div>
    );
  }
}

export default Surveys;
